const fileTypeList = [{
		componentName: 'SingleLineText',
		form_type: 'text',
		name: '单行文本',
		icon: require('./img/field_line.png')
	},
	{
		componentName: 'MultiLineText',
		form_type: 'textarea',
		name: '多行文本',
		icon: require('./img/field_multi_line.png')
	},
	{
		componentName: 'SelectForm',
		form_type: 'select',
		name: '下拉框',
		icon: require('./img/field_select.png')
	},
	{
		componentName: 'CheckboxForm',
		form_type: 'checkbox',
		name: '多选',
		icon: require('./img/field_checkbox.png')
	},
	{
		componentName: 'SingleLineText',
		form_type: 'number',
		name: '数字',
		icon: require('./img/field_number.png')
	},
	{
		componentName: 'SingleLineText',
		form_type: 'floatnumber',
		name: '货币',
		icon: require('./img/field_floatnumber.png')
	},
	{
		componentName: 'SingleLineText',
		form_type: 'mobile',
		name: '手机',
		icon: require('./img/field_mobile.png')
	},
	{
		componentName: 'SingleLineText',
		form_type: 'email',
		name: '邮箱',
		icon: require('./img/field_email.png')
	},
	{
		componentName: 'SingleLineText',
		form_type: 'date',
		name: '日期',
		icon: require('./img/field_date.png')
	},
	{
		componentName: 'SingleLineText',
		form_type: 'datetime',
		name: '日期时间',
		icon: require('./img/field_datetime.png')
	},
	{
		componentName: 'SingleLineText',
		form_type: 'user',
		name: '人员',
		icon: require('./img/field_user.png')
	},
	{
		componentName: 'SingleLineText',
		form_type: 'structure',
		name: '部门',
		icon: require('./img/field_structure.png')
	},
	{
		componentName: 'FileForm',
		form_type: 'file',
		name: '附件',
		icon: require('./img/field_file.png')
	}
]

export default fileTypeList
